import {CONSTANTS} from '@/config'

const requireResources = require.context('@/admin/menu/resources', true, /\.js$/);
let listResources = [];
for (const file of requireResources.keys()) {
  const resourceConfig = requireResources(file)
  listResources = listResources.concat(resourceConfig.default || resourceConfig);
}

export default [
  {
    name: 'Dashboard',
    title: 'route.dashboard',
    icon: 'mdi-view-dashboard'
  },
  {
    name: 'ManageUsers',
    role: [CONSTANTS.ROLES.SUPER_ADMINISTRATOR],
    title: 'menu.auth.manageUsers',
    icon: 'mdi-account-multiple'
  },
  {
    name: 'ManageDevices',
    title: 'Manage Devices',
    role: [CONSTANTS.ROLES.SUPER_ADMINISTRATOR, CONSTANTS.ROLES.COLLABORATOR],
    icon: 'mdi-axis',
  },
  {
    name: 'ManageLotteryResults',
    title: 'Quản lý kết quả',
    role: [CONSTANTS.ROLES.SUPER_ADMINISTRATOR],
    icon: 'mdi-axis',
  },
  /*{
    name: 'ManageOne789',
    title: 'Quản lý One789',
    role: [CONSTANTS.ROLES.SUPER_ADMINISTRATOR, CONSTANTS.ROLES.ONE_798_USER],
    icon: 'mdi-axis',
  },*/
  /*{
    title: 'menu.auth.title',
    icon: 'mdi-account-group',
    role: [CONSTANTS.ROLES.SUPER_ADMINISTRATOR],
    children: [
      {
        name: 'ManageUsers',
        title: 'menu.auth.manageUsers',
        icon: 'mdi-account-multiple'
      },
      {
        name: 'ManageRoles',
        title: 'menu.auth.manageRoles',
        icon: 'mdi-account-multiple-check',
      },
      {
        name: 'ManageScopes',
        title: 'menu.auth.manageScopes',
        icon: 'mdi-account-question',
      },
    ]
  },*/
  //-------------------------------
  /*{
    title: 'Resources',
    icon: 'mdi-alpha-r-box-outline',
    role: [CONSTANTS.ROLES.SUPER_ADMINISTRATOR],
    children: listResources,
  },*/
  //--------------------------------
  /*{
    title: 'route.config',
    icon: 'mdi-cog',
    children: [
      {
        name: 'Theme',
        title: 'route.theme',
        icon: 'mdi-palette'
      },
      {
        name: 'I18n',
        title: 'route.i18n',
        icon: 'mdi-translate'
      },
    ]
  },*/
  // ...permission,
  // ...vuetify,
  // ...componentDemo,
  // ...charts,
  // ...nested,
  // ...errorPages,
]
